import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import Logo from "../../assets/images/logo.svg"
import { scoreSelector } from "../../Redux/Game/gameSelector"


const Score = ({score}) => {
  return (
    <div className="w-10/12 mx-auto flex border-2 border-solid border-headerBorder rounded box-border max-w-sm mt-5 p-3 justify-between">
        <div className="w-28">
            <img className="w-full h-full" src={Logo} alt="logo"/>
        </div>
        <div className="bg-[#fff] flex flex-col items-center justify-center px-4 py-2 rounded">
            <h6 className="text-xs tracking-wider text-ScoreText">SCORE</h6>
            <span className="text-5xl text-ScoreTextDark">{score}</span>
        </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  score : scoreSelector
})

export default connect(mapStateToProps)(Score)